import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const Container = styled.div`
  height: 500px;
  overflow-y: auto;
  h3 {
    font-size: 28px;
    line-height: 32px;
    color: #000;
    font-weight: 900;
  }
  h4 {
    margin-bottom: 10px;
    font-size: 18px;
    line-height: 22px;
    color: #000;
    font-weight: 900;
  }
  h5 {
    font-size: 14px;
    line-height: 18px;
    color: #000;
    font-weight: 900;
    margin-bottom: 10px;
  }
  @media ${device.mobileS} {
    height: unset;
    flex: 1;
    overflow-y: unset;
  }
`;

export const Para = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 20px;
  span {
    font-weight: 700;
  }
`;
export const TncText = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #000;
  @media ${device.mobileS} {
    font-weight: 400;
  }
`;
